import { FC } from 'react';
import { ErrorPage } from '../../components';

export const NotAuthorized: FC = () => <ErrorPage>Not Authorized</ErrorPage>;
